import { environment } from '../environments/environment';

let dedicatedThemeReady: Promise<void> | null = null;

/**
 * Loads dedicatedcss/theme.css when `dedicatedCss` is enabled so :root variables
 * (header nav, landing sub-container, etc.) are applied before the first route renders.
 * Safe to call from APP_INITIALIZER and from route resolvers; shares one in-flight promise.
 */
export function ensureDedicatedThemeLoaded(): Promise<void> {
  if (!environment.dedicatedCss) {
    return Promise.resolve();
  }
  if (!dedicatedThemeReady) {
    dedicatedThemeReady = loadDedicatedThemeFromApi();
  }
  return dedicatedThemeReady;
}

export function dedicatedThemeAppInitializerFactory(): () => Promise<void> {
  return () => ensureDedicatedThemeLoaded();
}

async function loadDedicatedThemeFromApi(): Promise<void> {
  try {
    const res = await fetch(
      `${environment.baseApiUrl}api/Configuration/getDedicatedStorageConfig`,
    );
    if (!res.ok) {
      return;
    }
    const config = await res.json();
    const themeUrl = `https://${config.accountName}.file.core.windows.net/${config.container}/dedicatedcss/theme.css${config.sasToken}`;

    await new Promise<void>((resolve) => {
      let link = document.querySelector(
        'link[data-theme="dynamic-client-theme"]',
      ) as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.setAttribute('data-theme', 'dynamic-client-theme');
        document.head.appendChild(link);
      }
      const finish = () => resolve();
      link.onerror = () => {
        link.remove();
        finish();
      };
      link.onload = () => {
        document.querySelector('style[data-theme="dedicated-cache"]')?.remove();
        document.getElementById('fallback-theme')?.remove();
        try {
          localStorage.setItem('client-theme-url', `${themeUrl}&v=cached`);
          localStorage.removeItem('dedicated-theme-css');
        } catch {
          // ignore storage failures
        }
        finish();
      };
      link.href = `${themeUrl}&v=${Date.now()}`;
    });
  } catch {
    // keep index.html fallback theme
  }
}
